<template>
  <div class="page">
    <BreadCrumbs :items="[{ title: 'Мои заказы', url: '/my-orders' }]" />
    <div class="row">
      <div class="col d-flex align-center">
        <h1 class="font-lg">Мои заказы</h1>
      </div>
      <div class="col-auto d-flex align-center">
        <v-btn color="primary" :to="{ name: 'list-services' }">
          <v-icon left small>mdi-cart-outline</v-icon> Купить услуги
        </v-btn>
      </div>
    </div>
    <OrdersTable mode="my" />
  </div>
</template>

<script>
import OrdersTable from '@/components/orders/OrdersTable.vue';

export default {
  name: 'MyOrders',
  metaInfo: { title: 'Мои заказы' },
  components: { OrdersTable },
};
</script>
